import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FloralBg } from "@/components/FloralBg";

import SignIn from "@/pages/SignIn";
import StudentHome from "@/pages/StudentHome";
import CodingHub from "@/pages/CodingHub";
import Editor from "@/pages/Editor";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import TaskPage from "@/pages/TaskPage";
import Jobs from "@/pages/Jobs";
import Profile from "@/pages/Profile";
import Activity from "@/pages/Activity";
import Contact from "@/pages/Contact";
import SuperAdmin from "@/pages/SuperAdmin";
import AdminDash from "@/pages/AdminDash";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-teal-accent serif text-2xl animate-pulse">KiqHub…</div>
    </div>
  );
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin") return <Navigate to="/superadmin" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <StudentHome />;
}

function App() {
  return (
    <AuthProvider>
      <FloralBg />
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<SignIn />} />
          <Route path="/" element={<RootRedirect />} />
          <Route path="/coding" element={<Protected roles={["user"]}><CodingHub /></Protected>} />
          <Route path="/editor/new/:language" element={<Protected roles={["user"]}><Editor /></Protected>} />
          <Route path="/editor/:id" element={<Protected roles={["user"]}><Editor /></Protected>} />
          <Route path="/activity" element={<Protected roles={["user"]}><Activity /></Protected>} />
          <Route path="/contact" element={<Protected roles={["user"]}><Contact /></Protected>} />
          <Route path="/courses" element={<Protected roles={["user"]}><Courses /></Protected>} />
          <Route path="/courses/:id" element={<Protected roles={["user"]}><CourseDetail /></Protected>} />
          <Route path="/courses/:id/day/:day" element={<Protected roles={["user"]}><TaskPage /></Protected>} />
          <Route path="/jobs" element={<Protected roles={["user"]}><Jobs /></Protected>} />
          <Route path="/profile" element={<Protected roles={["user"]}><Profile /></Protected>} />
          <Route path="/superadmin" element={<Protected roles={["super_admin"]}><SuperAdmin /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDash /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
